import {EventBroker} from "@frontend/lib/utils/event-broker";

export const SHOW_PAGE_EVENTS = {
  LAYOUT_READY: 'LAYOUT_READY'
}

export const ShowPageEventBroker = new EventBroker()